import { Component } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { WjGridModule } from '@grapecity/wijmo.angular2.grid'
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter'
import { DataMap } from '@grapecity/wijmo.grid'

import { BaseComponent, ConfinedSpaceEntryPermit, FeatureType, Grid, ListItem, ModalSize, VpJob } from '../../shared'
import { ActionToolbarButtonsComponent } from '../../shared/reusable-components/action-toolbar-buttons/action-toolbar-buttons.component'
import { ActionToolbarCount } from '../../shared/reusable-components/action-toolbar-count/action-toolbar-count.component'
import { ActionToolbarSearchComponent } from '../../shared/reusable-components/action-toolbar-search/action-toolbar-search.component'
import { GridExportComponent } from '../../shared/reusable-components/grid-export/grid-export.component'
import { AutoSizeDirective } from '../../shared/utility/auto-size.directive'
import { ConfinedSpaceEntryPermitComponent } from './confined-space-entry-permit.component'

@Component({
    selector: 'app-confined-space-entry-permits',
    templateUrl: './confined-space-entry-permits.component.html',
    standalone: true,
    imports: [
        FormsModule,
        ActionToolbarCount,
        ActionToolbarButtonsComponent,
        ActionToolbarSearchComponent,
        GridExportComponent,
        WjGridModule,
        AutoSizeDirective,
        WjGridFilterModule,
    ],
})
export class ConfinedSpaceEntryPermitsComponent extends BaseComponent {
    public grid: Grid<ConfinedSpaceEntryPermit>

    jobMap!: DataMap
    activeJobList: ListItem<string>[] = []
    allJobs: VpJob[] = []

    constructor() {
        super()
        this.grid = new Grid<ConfinedSpaceEntryPermit>(this.services)
            .setupModalEditing(
                this.services.data.confinedSpaceEntryPermits,
                'Confined Space Entry Permit',
                ConfinedSpaceEntryPermitComponent,
                () => ConfinedSpaceEntryPermit.createNew(),
                this,
                ModalSize.extraLarge,
            )
            .wrapColumnHeaders()
            .filterBy(item => [
                item.job,
                item.jobDisplay,
                item.address,
                item.jobSiteSpaceId,
                item.jobSupervisor,
                item.workToBePerformed,
                item.entrantNames,
                item.attendantPersonnel,
            ])
        this.grid.canEdit = this.canEdit
        this.grid.canAdd = this.canEdit
        this.grid.canDelete = this.canEdit
        this.refresh()
    }

    public refresh() {
        this.cancelableRequest(
            '',
            true,
            this.services.data
                .load(true, true, this.services.data.vpJobs.queryAllByAction('GetAllJobs'), this.services.data.confinedSpaceEntryPermits.queryAll())
                .subscribe({
                    next: result => {
                        this.initialLoadingComplete()

                        const allJobs = result[0] as VpJob[]
                        this.allJobs = allJobs
                        this.activeJobList = allJobs
                            .filter(job => job.jobStatus === 1)
                            .sort((a, b) => a.id.trim().localeCompare(b.id.trim(), undefined, { numeric: true }))
                            .map(job => new ListItem(job.id, `${job.id.trim()} ${job.name}`))
                        this.jobMap = new DataMap(
                            allJobs.map(j => ({ id: j.id, display: `${j.id.trim()} ${j.name}` })),
                            'id',
                            'display',
                        )

                        const items = result[1] as ConfinedSpaceEntryPermit[]
                        for (const item of items) {
                            item.jobDisplay = this.jobDisplayForItem(item.job)
                        }
                        this.grid.items = items
                    },
                }),
        )
    }

    jobDisplayForItem(jobId: string | null | undefined): string {
        if (!jobId) return ''
        const job = this.allJobs.find(j => j.id === jobId || j.id.trim() === jobId.trim())
        return job ? `${job.id.trim()} ${job.name}` : jobId
    }

    public get canEdit() {
        return this.services.authentication.hasFeature([FeatureType.SafetyChecklistEdit])
    }
}
